import { createGlobalStyle } from 'styled-components';
// import texture from '../static/images/texture.png';

export default createGlobalStyle`

  html {
    -ms-text-size-adjust: 100%;
    -webkit-text-size-adjust: 100%;
  }

  body {
    width: 100%;
    position: relative;
    left: 0;
    -webkit-overflow-scrolling: touch;
    line-height: 1.5em;
    font-family: 'Ubuntu', sans-serif;
    font-weight: 400;
    font-size: 16px;
  }

  .content-wrap {
    width: 100%;
    max-width: 630px;
    margin: 0 auto;
    padding: 2px;
  }

  .chart-wrap {
    margin-top: 40px;
  }

  h4 {
    margin-bottom: 8px;
  }

  .headline {
    font-family: 'Ubuntu', sans-serif;
    font-size: 24px;
    line-height: 34px;
    font-weight: 700;
    border-left: 4px solid #cf1a17;
    padding-left: 16px;
    margin-bottom: 20px;
  }

  .selectItem {
    margin-bottom: 20px;
  }

  label {
    margin-left: 4px;
    margin-right: 15px;
  }

  svg {
    font-weight: 300;
    font-size: 8px;
    font-family: 'Ubuntu', sans-serif;
  }

  .x-axis,
  .y-axis,
  .x-axis-L,
  .x-axis-b,
  .y-axis-b {
    pointer-events: none;
  }

  .x-axis .domain,
  .x-axis-L .domain,
  .y-axis .domain,
  .x-axis-b .domain,
  .y-axis-b .domain {
    opacity: 0;
  }

  .x-axis line,
  .x-axis-L line,
  .y-axis line,
  .x-axis-b line {
    stroke: #999;
    opacity: 0;
  }

  .y-axis line {
    stroke: #999;
    opacity: 0.5
  }

  .x-axis .tick text,
  .x-axis-L .tick text,
  .y-axis-b .tick text {
    fill: #777;
    font-family: 'Ubuntu', sans-serif;
    font-size: 11px;
  }

  .y-axis .tick text,
  .x-axis-b .tick text {
    display: none;
  }

  .area-chart-left {
    // fill: #f06f10;
    opacity: 1;
  }

  .area-chart-right {
    // fill: #e12827;
    opacity: 1;
  }

  .text-indicator {
    font-family: 'Ubuntu', sans-serif;
    font-size: 16px;
    font-weight: 700;
    alignment-baseline: middle;
  }

  @media (max-width: 480px) {
    .text-indicator {
      font-size: 12px;
    }
  }

  .text-hints-earn {
    font-family: 'Ubuntu', sans-serif;
    fill: #fff;
    font-weight: 700;
    font-size: 16px;
    opacity: 0.4;
  }

  @media (max-width: 440px) {
    .text-hints-earn {
      font-size: 14px;
    }
  }

  .text-hint-y-axis {
    fill: #777;
    font-family: 'Raleway', sans-serif;
    font-size: 12px;
  }

  .earn-less-colour {
    color: #f06f10;
  }

  .earn-more-colour {
    color: #e12827;
  }

  .you {
    font-family: 'Ubuntu', sans-serif;
    font-size: 18px;
    font-weight: 700;
  }

  .standard-error {
    font-size: 12px;
    line-height: 14px;
    padding: 10px 0;
  }

  .arrow-hint-text {
    font-size: 12px;
    font-family: 'Ubuntu', sans-serif;
    font-weight: 700;
    text-transform: uppercase;
  }

  @media (max-width: 500px) {
    .arrow-hint-text {
      font-size: 8px;
    }
  }

  .source {
    margin-top: 20px;
    margin-bottom: 20px;
    height: 40px;
    width: 100%;
    position: relative;
    font-size: 12px;
  }

  .annoation-helper {
    padding: 12px 20px; 
    background: url('images/textureDark2.jpg');
    border-radius: 20px;
    color: white;
    font-family: 'Ubuntu', sans-serif;
  }

  h3, h4, .selectItem {
    font-family: 'Ubuntu', sans-serif;
  }

  .image-header {
    position: relative;
    margin: 10px auto;
    width: 100%;
    max-width: 630px;
    height: auto;
  }

`;
